import { useId, useState, type ReactNode } from "react";
import { Button } from "@/shared/ui";
import { useBrowserWorkspaceChrome } from "@/shared/ui/BrowserWorkspaceChrome";
import { CaretDownIcon, PanelLeftIcon } from "@/shared/ui/icons";
import "./BrowserWorkspace.css";

/** Shared pane geometry for Assets, Projects, and Library. Without navigation the content takes the full width. */
export function BrowserWorkspaceLayout({ navigation, navigationLabel = "Workspace navigation", browseLabel = "Browse", children }: {
  navigation?: (close: () => void) => ReactNode;
  navigationLabel?: string;
  browseLabel?: string;
  children: ReactNode;
}) {
  const chrome = useBrowserWorkspaceChrome();
  const sidebarID = useId();
  const [expanded, setExpanded] = useState(false);
  if (!navigation) return <div className="browser-workspace" data-split-panes={Boolean(chrome) || undefined}>
    <div className="browser-workspace-layout" data-single-pane="">
      <div className="browser-workspace-content">{chrome?.header}{children}</div>
    </div>
  </div>;
  return <div className="browser-workspace" data-split-panes={Boolean(chrome) || undefined}>
    <div className="browser-workspace-layout">
      <div className="browser-sidebar-toggle">
        <Button variant="ghost" size="sm" aria-expanded={expanded} aria-controls={sidebarID} onClick={() => setExpanded(value => !value)}>
          <PanelLeftIcon />{browseLabel}<CaretDownIcon />
        </Button>
      </div>
      <aside id={sidebarID} className="browser-sidebar" data-expanded={expanded || undefined} aria-label={navigationLabel}>
        {chrome?.workspaceControls ? <div className="browser-sidebar-workspace">{chrome.workspaceControls}</div> : null}
        {navigation(() => setExpanded(false))}
      </aside>
      <div className="browser-workspace-content">{chrome?.header}{children}</div>
    </div>
  </div>;
}
